// JavaScript Document
var scheduleArray = [];


jQuery(window).on("load", function() {
	"use strict";


	jQuery("table#tbl_schedule tbody").each(function(){
		scheduleArray.push(new Schedule(
							jQuery(this).find("td.day").html(),
							jQuery(this).find("td.time").html(),
							jQuery(this).find("td.deadline").html()
						));

	});

	jQuery("select#select_date").change(function(){
		jQuery("select#select_time").html(createTimeOption());
	});



	/* 地図 */
var $gmap = jQuery("div#gmap");
var lat = parseFloat($gmap.attr("data-lat"));
var lng = parseFloat($gmap.attr("data-lng"));

if ($gmap.length && !isNaN(lat) && !isNaN(lng)) {
	loadmap("gmap", "ベース", lat, lng, false);	// jshint ignore:line
	$gmap.show();
} else {
	$gmap.hide();
}

	//対面・オンラインの表示
	if(parseInt(jQuery("input#event_online").val()) !== 3){
	   jQuery("dl#event_type").remove();
	}

	//初期値
	jQuery("select#select_date").html(createDateOption());
	jQuery("select#select_time").html(createTimeOption());

});


/*
*  ===============================================================
*	スケジュール
*  ===============================================================
*/
/* Scheduleクラス */
function Schedule(_date,_time,_limit) {
	"use strict";

	this.date = _date.trim();
	this.time = _time.trim();

	if(_limit.trim() !== ""){
		var tmpLimitArray = _limit.replace(/[^0-9\/]/g, '').split("/");
		this.limit = new Date(tmpLimitArray[0],tmpLimitArray[1]-1,tmpLimitArray[2]);
	}else{
		this.limit = new Date(3000,0,1);
	}

}
/* 日付の選択肢生成 */
function createDateOption(){
	"use strict";

	var tmpDateArray = [];	//同じ日チェック用
	var tmpScheduleArray = [];
	scheduleArray.forEach(function(elem, index) {
		if(tmpDateArray.indexOf(elem.date) === -1){
			tmpDateArray.push(elem.date);
			tmpScheduleArray.push(elem);
		}
	});

	var nowdate = new Date();
	var content = "";
	content += "<option value=''>";
	content += "--選択してください--";
	content += "</option>";
	tmpScheduleArray.forEach(function(elem, index) {
		//if(nowdate > elem.limit){
		if(isAllLimit(elem.date)){
			content += "<option value='" + elem.date + "' disabled>";
			content += elem.date + " (申込期限が過ぎています)";
		}else{
			content += "<option value='" + elem.date + "'>";
			content += elem.date;
		}
		content += "</option>";
	});

	return content;
}
/* 時間の選択肢生成 */
function createTimeOption(){
	"use strict";

	var nowdate = new Date();
	var selectDate = jQuery("select#select_date").val();
	var content = "";
	content += "<option value=''>";
	content += "--選択してください--";
	content += "</option>";
	scheduleArray.forEach(function(elem, index) {
		if(elem.date === selectDate){
			if(nowdate > elem.limit){
				content += "<option value='" + elem.time + "' disabled>";
				content += elem.time + " (申込期限が過ぎています)";
			}else{
				content += "<option value='" + elem.time + "'>";
				content += elem.time;
				content += "</option>";
			}
		}
	});

	return content;
}

/* 同じ日はすべて期限過ぎているか */
function isAllLimit(_date){
	var nolimit_count = 0;	//期限切れてない数

	var nowdate = new Date();
	scheduleArray.forEach(function(elem, index) {
		if(elem.date === _date && nowdate <= elem.limit){
			nolimit_count++;
		}
	});

	return nolimit_count === 0;
}




